import React, {useContext, useEffect, useState} from "react";
import _ from "lodash";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {PhotoIcon} from "@heroicons/react/20/solid";
import DesignInfoFilters from "./design-info-filters";
import {getDataFromLocalStorage, setDataInLocalStorage} from "../../../common/utils/local-storage-util";
import {
    DESIGN_INFO_FILTER_FOR_SELECT_IMAGES_FIELDS,
    DESIGN_INFO_KEYS,
} from "../../constants/design-info.constant";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import appContext from "../../../common/context/app-context";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";
import {
    getSingleDesignProduct,
} from "../../services/design-product-data.service";
import {XMarkIcon} from "@heroicons/react/24/solid";


const defaultFilterCriteria: any = {};

const SelectDesignProductImages = ({
                                       allDesignInfo,
                                       allDesigns = null,
                                       layer,
                                       setSelectedLayer = undefined,
                                       mediaFor = undefined,
                                       handleSelectedProductImageInLayer,
                                       isSingleImageSelection = false,
                                       handleBulkSelectedProductImageInLayer = undefined,
                                   }) => {
    let {shopifyDetail, removeShopifyProduct} = useContext(appContext);
    const [showModal, setShowModal] = useState(false);
    const [designList, setDesignList] = useState(null);
    const [filteredDesignList, setFilteredDesignList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [selectedImages, setSelectedImages] = useState([]);
    const [selectedDesign, setSelectedDesign] = useState(null);
    const [designProduct, setDesignProduct] = useState(null);
    const [isBulkSelect, setIsBulkSelect] = useState(false);

    useEffect(() => {

        if (showModal) {
            if (setSelectedLayer) {
                setSelectedLayer(layer);
            }

            setIsBulkSelect(false);
            setSelectedImages([]);
            initDesignList();
        }

    }, [showModal]);

    const handleConfirmAction = async () => {
        if (handleBulkSelectedProductImageInLayer && isBulkSelect && selectedImages?.length > 0) {
            handleBulkSelectedProductImageInLayer(selectedImages);
        }

        setShowModal(false);
    }

    const handleCloseAction = () => {
        setShowModal(false);
    }

    const initDesignList = async () => {
        setDesignList(allDesigns);
        setFilteredDesignList(allDesigns);

        let existingFilters = getDataFromLocalStorage(DESIGN_INFO_KEYS.DESIGN_PRODUCT_IMAGES_FILTERS);

        if (mediaFor) {
            existingFilters = {};
            existingFilters['parent'] = mediaFor.parent;
        }

        setFilterCriteria(existingFilters || defaultFilterCriteria);
    }

    useEffect(() => {
        if (!_.isEmpty(designList)) {
            applyFilters();
            setDataInLocalStorage(DESIGN_INFO_KEYS.DESIGN_PRODUCT_IMAGES_FILTERS, filterCriteria);
        }
    }, [filterCriteria]);

    const applyFilters = () => {
        let filteredList = [...designList];
        let existingFilterCriteria = {...filterCriteria};
        const filters = {};

        _.forEach(existingFilterCriteria, (filterValue, filterKey) => {
            if (filterValue) {
                if (filterValue === 'Yes') {
                    filters[filterKey] = true;
                } else if (filterValue === 'No') {
                    filters[filterKey] = false;
                } else {
                    filters[filterKey] = filterValue;
                }
            }
        });

        filteredList = _.filter(filteredList, filters);
        setFilteredDesignList(filteredList);

        setSelectedDesign(filteredList[0]);
        getDesignProductForDesign(filteredList[0]);
    }

    const getDesignProductForDesign = async (design) => {
        const designProductDetail = await getSingleDesignProduct(design?.id);
        setDesignProduct(designProductDetail);
    }

    const selectRandomImages = () => {
        let currentSelectedImages = [];
        designProduct?.productsList?.forEach((product) => {
            if (product?.images?.length > 0) {
                const randomIndex = Math.floor(Math.random() * product?.images?.length);
                const randomImage = product?.images[randomIndex];
                randomImage.onlineStoreUrl = product?.onlineStoreUrl;
                randomImage.title = product?.title;
                randomImage.handle = product?.handle;
                currentSelectedImages.push(randomImage);
            }
        });

        setSelectedImages(currentSelectedImages);
        setIsBulkSelect(true);
    }

    const handleSingleImageSelection = (productImage, product) => {
        if (selectedImages?.find((selectedFeaturedImage) => selectedFeaturedImage?.id === productImage?.id)) {
            setSelectedImages(_.filter(selectedImages, (selectedFeaturedImage) => selectedFeaturedImage?.id !== productImage?.id));
        } else {
            const selectedProductImage = _.cloneDeep(productImage);
            selectedProductImage.onlineStoreUrl = product?.onlineStoreUrl;
            selectedProductImage.title = product?.title;
            selectedProductImage.handle = product?.handle;
            setSelectedImages([...selectedImages, selectedProductImage]);
        }
    }

    return (
        <>

            <button
                className="button-purple-outline px-2 py-1 flex justify-center items-center mr-2"
                onClick={() => {
                    setShowModal(true);
                }}>
                <PhotoIcon className="h-5 w-5"/>
            </button>

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-3/4 my-6 mx-auto">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-gray-100 outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        Select Product Images
                                        <span className={'ml-1'}>({selectedImages?.length})</span>
                                    </h3>

                                    <button
                                        className="button-purple-outline px-2 py-1 flex justify-center items-center mr-2"
                                        onClick={selectRandomImages}>
                                        Select Random Images
                                    </button>

                                    <div className="">
                                        <button
                                            className="button-gray-outline px-1 py-1"
                                            onClick={handleCloseAction}>
                                            <div className="">
                                                <XMarkIcon className="h-6 w-6"/>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                {/*body*/}
                                <div className="relative p-5 flex-auto">
                                    <div className={'w-full flex'}>
                                        {designList?.length > 0 &&
                                            <div
                                                className={'w-full flex justify-start items-start'}>
                                                <DesignInfoFilters
                                                    dataFetchInProgress={false}
                                                    allDesignInfo={allDesignInfo}
                                                    showSecondaryFilters={false}
                                                    containerClass={''}
                                                    allFilterFields={DESIGN_INFO_FILTER_FOR_SELECT_IMAGES_FIELDS}
                                                    fieldClass={'w-fit'}
                                                    filterCriteria={filterCriteria}
                                                    setFilterCriteria={setFilterCriteria}/>
                                            </div>
                                        }

                                        <div className="mx-2">
                                            <ShowProgressSpinner
                                                dataFetchInProgress={false}/>
                                        </div>
                                    </div>

                                    <div className="flex justify-start mt-4">

                                        <div className="w-1/3">

                                            <ShowEmptyListMessage
                                                dataList={filteredDesignList}
                                                dataFetchInProgress={false}
                                                label={'Design Info'}/>

                                            {filteredDesignList?.length > 0 &&
                                                <div
                                                    className={'table-container-with-filter-2-rows bg-white overflow-y-scroll border border-gray-400 rounded-lg'}>

                                                    <table className="w-full">
                                                        <thead className="">
                                                        <tr>
                                                            <th className="p-2 border-y border-gray-400 bg-gray-400 text-white sticky top-0 w-12">S.No</th>
                                                            <th className="p-2 border-y border-gray-400 bg-gray-400 text-white sticky top-0">Name</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody className="">
                                                        {filteredDesignList?.map((design, rowIndex) => (
                                                            <tr key={`row-${rowIndex}`}
                                                                onClick={() => {
                                                                    setSelectedDesign(design);
                                                                    getDesignProductForDesign(design);
                                                                }}
                                                                className={`border-b border-gray-400 cursor-pointer hover:bg-green-100 ${selectedDesign?.id === design?.id ? 'bg-green-200' : ''}`}>
                                                                <td className="p-2 m-auto">
                                                                    <div className="flex justify-center w-12">
                                                                        {rowIndex + 1}
                                                                    </div>
                                                                </td>

                                                                <td className={`p-2 m-auto`}>
                                                                    {design?.name}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>

                                                </div>
                                            }
                                        </div>

                                        <div className={'w-2/3'}>
                                            <div
                                                className="ml-4 table-container-with-filter-2-rows flex flex-wrap content-start justify-start overflow-y-scroll mx-2 p-4 border border-gray-400 bg-gray-400 rounded-lg">
                                                {designProduct?.productsList?.length > 0 &&
                                                    <>
                                                        {designProduct?.productsList?.map((product, productIndex) => (
                                                            <div key={productIndex}>
                                                                <div
                                                                    className={'text-sm text-white mb-2 text-left'}>{product?.title}</div>
                                                                <div
                                                                    className="flex flex-wrap justify-start mb-6">
                                                                    {product?.images?.map((productImage, productImageIndex) => (
                                                                        <ProductImageSmall
                                                                            afterImageSelected={(event) => {
                                                                                handleSingleImageSelection(productImage, product);

                                                                                if (isSingleImageSelection && handleSelectedProductImageInLayer) {
                                                                                    handleSelectedProductImageInLayer(productImage, product);
                                                                                }
                                                                            }}
                                                                            dimension={100}
                                                                            isSelected={selectedImages?.find((selectedFeaturedImage) => selectedFeaturedImage?.id === productImage?.id)}
                                                                            key={`selected-product-image-${productImageIndex}`}
                                                                            imageUrl={productImage?.url}/>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-blueGray-200 rounded-b">
                                    <button
                                        className="ml-2 text-gray-500 font-bold border border-gray-500 h-8 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-8 px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default SelectDesignProductImages
